<template>
  <div class="masked-phone">
    <span>{{ display }}</span>
    <el-button v-if="hasPermission && customerId && !plain" type="text" size="mini" @click="reveal">查看</el-button>
    <el-tooltip v-else-if="!hasPermission" content="无权限查看完整手机号，请联系管理员" placement="top">
      <i class="el-icon-warning-outline no-permission-tip"></i>
    </el-tooltip>
  </div>
</template>

<script>
import childFollowupApi from '@/api/cust/childFollowup'

// ⚠️ 权限点以**增量 SQL 里写进 sys_menu 的那个**为准（后端 checkPermission 用的也是它）。
//    原来这里写的是 cust:childFollowup:phone —— 库里根本没有这个权限点，
//    结果是：被授权的普通账号永远看不到「查看」按钮，只有超管（*:*:*）看得到，测试用超管验所以没发现。
const VIEW_PHONE_PERMISSION = 'finance:subaccountFollowup:viewPhone'

/**
 * 手机号脱敏展示（REQ-2026-601171 §G）
 * 默认脱敏 138****7321；有「客户完整手机号查看」权限才允许调明文接口，无权限提示联系管理员
 * 后端按权限决定返回明文或脱敏，这里的权限判断只是前端不给按钮，真正兜底在后端
 */
export default {
  name: 'MaskedPhone',
  props: {
    customerId: { type: [Number, String], default: null },
    // 回访任务 id。后端据此把"谁在哪条任务上看了谁的手机号"写进审计日志，不传的话日志里少一个维度
    followupId: { type: [Number, String], default: null },
    masked: { type: String, default: '' }
  },
  data() {
    return {
      plain: ''
    }
  },
  computed: {
    hasPermission() {
      const permissions = (this.$store.getters && this.$store.getters.permissions) || []
      return permissions.includes('*:*:*') || permissions.includes(VIEW_PHONE_PERMISSION)
    },
    display() {
      return this.plain || this.masked || '—'
    }
  },
  methods: {
    reveal() {
      childFollowupApi.fetchPhone(this.customerId, this.followupId).then(({ data }) => {
        // 返回体是 { customerId, phone }，不是一个裸字符串 —— 原来直接 this.plain = data，页面上显示的是 [object Object]
        this.plain = (data && data.phone) || ''
      }).catch((error) => {
        this.$common && this.$common.showNotifyError(error)
      })
    }
  }
}
</script>

<style scoped>
.masked-phone {
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-permission-tip {
  margin-left: 4px;
  color: #e6a23c;
}
</style>
